export default function (app, imgurl) {
    var $ = require('jquery');
    var _ = require('lodash');
  
    app.directive('slider', function () {
        return {
            template: require('./template.html'),
            controller: ['$scope', 'Lightbox','$element','$timeout', function Controller($scope, Lightbox,$element,$timeout) {

            
                    $scope.imag = _.map(_.reject($scope.images, _.isNull), function (i) {
                        return {
                            "url": imgurl + i.url.substring(0, 4) + '/' + i.url,
                            "date": i.date,
                            "caption": i.caption
                        };
                    });
                    

                    $scope.open = function (images, index) {
                        Lightbox.openModal(images, index);
                    };
                    
                }],
            scope: {
                images: '='
            }
        };
    });
}


// WEBPACK FOOTER //
// ./src/slider/index.js